import {AfterViewInit, Component} from "@angular/core";
import {ActivatedRoute} from "@angular/router";


import {Api} from "../../generated/api/hydrosolid-portal/api";
import {siteInviteControllerAcceptInvite} from "../../generated/api/hydrosolid-portal/functions";
import {ModalController} from "@ionic/angular";


enum InviteState {
  INIT,
  OK,
  ERROR,
}

@Component({
  selector: "app-accept-invite",
  standalone: false,
  templateUrl: "./accept-invite.component.html",
})
export class AcceptInviteComponent implements AfterViewInit {

  public state = InviteState.INIT;

  protected readonly InviteState = InviteState;

  constructor(
    private api: Api,
    private route: ActivatedRoute,
  ) {
  }

  ngAfterViewInit(): void {

    const inviteToken = this.route.snapshot.queryParamMap.get("token") as string | undefined;

    if (!inviteToken) {
      this.state = InviteState.ERROR;
      return;
    }
    this.api.invoke(siteInviteControllerAcceptInvite, {

      body: {
        inviteToken,
      },
    }).then(() => {
      this.state = InviteState.OK;
    }).catch(() => this.state = InviteState.ERROR);
  }

}
